import React, { FC } from 'react';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import translate from '@translate';
import Dialog from 'src/components/Dialog';
import Grid, { GridItem } from 'src/components/Grid';
import OptionsSimpleTable from 'src/components/OptionsSimpleTable';
import Typography from '../../components/Typography';

export interface ColumnOptionsProps {
    handlingUnitsCodes: ConstantsCodeType[];
    receivingDeliveryTypeCodes: ConstantsCodeType[];
    driverCompanyCodes: ConstantsCodeType[];
    receivingTypeCodes: ConstantsCodeType[];
    boolNumberCodes: ConstantsCodeType[];
    incotermsCodes: ConstantsCodeType[];
    onClose: () => void;
}

const ColumnOptions: FC<ColumnOptionsProps> = (props) => {
    return (
        <Dialog
            maxWidth="md"
            title={translate('receivingImport.columnsOptions')}
            onClose={props.onClose}
            sx={{
                paddingBottom: 0,
                '& .MuiDialogTitle-root': { paddingBottom: 0 },
                '& .MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-2': { marginTop: 0 },
            }}
        >
            <Grid>
                <GridItem cols={12}>
                    <Typography variant="body1">ESHOP_RECEIVING_ID: {translate('receivingImport.eshopReceivingIdColumnDescription')}</Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">ESTIMATED_DELIVERY: {translate('format')} YYYY/MM/DD HH:MM</Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <Typography variant="body1">PRODUCT_EXPIRATION_DATE: {translate('format')} YYYY/MM/DD</Typography>
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="DELIVERY_TYPE" options={props.receivingDeliveryTypeCodes} />
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="DRIVER_COMPANY" options={props.driverCompanyCodes} />
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="RECEIVING_TYPE" options={props.receivingTypeCodes} />
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="DUTY" options={props.boolNumberCodes} />
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="PRIORITY" options={[
                        { label: translate('utils.orderPriorityCodes.normal'), value: '0' },
                        { label: translate('utils.orderPriorityCodes.high'), value: '1' }
                    ]} />
                </GridItem>
                <GridItem cols={12}><p></p></GridItem>
                <GridItem cols={12}>
                    <OptionsSimpleTable keyText="INCOTERMS" options={props.incotermsCodes} />
                </GridItem>
            </Grid>
        </Dialog>
    );
};

export default ColumnOptions;
